import dynamic from "next/dynamic";

export const DynamicLayoutWidget066 = dynamic(
  () => import("./LayoutWidget066"),
  {
    suspense: true,
  }
);
